/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

import { clearNumber } from './clear-number';

/**
 * Format a string to only have numbers
 */
export function formatNumber(value: string) {
  return clearNumber(value);
}
